import _isEmpty from 'underscore/cjs/isEmpty.js'

export function GENERATE_AGGREGATE_RATING (trustpilot = {}) {
  return {
    '@type': 'AggregateRating',
    '@id': `${CC_DOMAIN}/#aggregaterating`,
    ratingValue: trustpilot?.rating ?? '4.6',
    bestRating: '5',
    worstRating: '1',
    ratingCount: trustpilot?.count ?? '9410'
  }
}

export function GENERATE_ORGANIZATION_SCHEMA (trustpilot = {}) {
  return {
    '@type': 'Organization',
    '@id': `${CC_DOMAIN}/#organization`,
    name: 'Compare Club',
    legalName: 'Compare Club Australia Pty Ltd',
    alternateName: 'Compare Club Australia',
    url: `${CC_DOMAIN}/`,
    description: 'We\'re experts in saving Australians money on health insurance, home loans, energy bills, and life insurance.',
    logo: {
      '@id': `${CC_DOMAIN}/#logo`
    },
    image: {
      '@id': `${CC_DOMAIN}/#logo`
    },
    telephone: '+611300112582',
    email: 'info@compareclub.com.au',
    numberOfEmployees: {
      '@type': 'QuantitativeValue',
      value: 300,
      unitText: 'Australian-based experts'
    },
    identifier: [
      {
        '@type': 'PropertyValue',
        propertyID: 'AFS Representative Number',
        value: '001279036'
      },
      {
        '@type': 'PropertyValue',
        propertyID: 'Credit Representative Number',
        value: '519886'
      }
    ],
    memberOf: {
      '@type': 'Organization',
      name: 'Private Health Insurance Intermediaries Association',
      alternateName: 'PHIIA',
      url: 'https://phiia.com.au/'
    },
    address: {
      '@type': 'PostalAddress',
      '@id': `${CC_DOMAIN}/#headquarters`,
      streetAddress: 'Level 10, 201 Sussex Street',
      addressLocality: 'Sydney',
      addressRegion: 'NSW',
      postalCode: '2000',
      addressCountry: 'AU'
    },
    location: [
      {
        '@type': 'Place',
        '@id': `${CC_DOMAIN}/#office-sydney`,
        name: 'Compare Club — Sydney',
        address: {
          '@id': `${CC_DOMAIN}/#headquarters`
        }
      },
      {
        '@type': 'Place',
        '@id': `${CC_DOMAIN}/#office-melbourne`,
        name: 'Compare Club — Melbourne',
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Level 6, 600 St Kilda Road',
          addressLocality: 'Melbourne',
          addressRegion: 'VIC',
          postalCode: '3004',
          addressCountry: 'AU'
        }
      },
      {
        '@type': 'Place',
        '@id': `${CC_DOMAIN}/#office-brisbane`,
        name: 'Compare Club — Brisbane',
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Level 3, 324 Queen Street',
          addressLocality: 'Brisbane City',
          addressRegion: 'QLD',
          postalCode: '4000',
          addressCountry: 'AU'
        }
      }
    ],
    sameAs: [
      'https://www.facebook.com/compareclubau/',
      'https://www.instagram.com/compareclub_au/',
      'https://twitter.com/CompareClub/',
      'https://au.linkedin.com/company/compare-club/',
      'https://www.tiktok.com/@compareclub_au',
      'https://www.youtube.com/@compareclub'
    ],
    contactPoint: [
      {
        '@type': 'ContactPoint',
        '@id': `${CC_DOMAIN}/#contact-health`,
        contactType: 'customer service',
        telephone: '+611300757819',
        areaServed: 'AU',
        availableLanguage: [
          'en'
        ],
        productSupported: 'Health Insurance Comparison',
        hoursAvailable: {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday'
          ],
          opens: '08:00',
          closes: '20:00'
        }
      },
      {
        '@type': 'ContactPoint',
        '@id': `${CC_DOMAIN}/#contact-life`,
        contactType: 'customer service',
        telephone: '+611300598418',
        areaServed: 'AU',
        availableLanguage: [
          'en'
        ],
        productSupported: 'Life Insurance Comparison',
        hoursAvailable: {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday'
          ],
          opens: '08:00',
          closes: '20:00'
        }
      },
      {
        '@type': 'ContactPoint',
        '@id': `${CC_DOMAIN}/#contact-homeloan`,
        contactType: 'customer service',
        telephone: '+611300190429',
        areaServed: 'AU',
        availableLanguage: [
          'en'
        ],
        productSupported: 'Home Loan Comparison',
        hoursAvailable: {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday'
          ],
          opens: '08:00',
          closes: '20:00'
        }
      }
    ],
    aggregateRating: GENERATE_AGGREGATE_RATING(trustpilot)
  }
}

export function GENERATE_LOGO_SCHEMA ({
  articleUrl = `${CC_DOMAIN}/#logo`,
  imageUrl = `${APP_ASSET_BASEURL}edge/static/logo.svg`,
  caption = 'Compare Club',
  width,
  height
} = {}) {
  return removeFalseyObj({
    '@type': 'ImageObject',
    '@id': articleUrl,
    'inLanguage': 'en-AU',
    'url': imageUrl,
    'contentUrl': imageUrl,
    caption,
    width,
    height
  })
}

export const SCHEMA_WEBSITE = {
  '@context': 'https://schema.org/',
  '@type': 'WebSite',
  '@id': `${CC_DOMAIN}/#website`,
  'url': `${CC_DOMAIN}/`,
  'name': 'Compare Club',
  'alternateName': 'Compare Club Australia',
  'description': 'Health & Life Insurance, Energy, Loans & More',
  'publisher': {
    '@id': `${CC_DOMAIN}/#organization`
  },
  'inLanguage': 'en-AU',
  'potentialAction': {
    '@type': 'SearchAction',
    'target': {
      '@type': 'EntryPoint',
      'urlTemplate': `${CC_DOMAIN}/?s={search_term_string}`
    },
    'query-input': 'required name=search_term_string'
  }
}

export function GENERATE_WEBPAGE_SCHEMA ({
  type = 'WebPage',
  page,
  aboutPath,
  mainEntityPath,
  primaryImageOfPagePath,
  breadcrumbPath,
  pageTitle,
  pageDescription,
  datePublished,
  dateModified
} = {}) {
  const typeValue = type || 'WebPage'

  const pageUrl = trailingSlash(`${CC_DOMAIN}${page}`)

  return removeFalseyObj({
    '@type': typeValue,
    '@id': `${pageUrl}#webpage`,
    url: `${pageUrl}`,
    name: pageTitle,
    description: pageDescription,
    isPartOf: {
      '@id': `${CC_DOMAIN}/#website`
    },
    about: {
      '@id': `${CC_DOMAIN}${aboutPath}`
    },
    mainEntity: mainEntityPath ? {
      '@id': `${CC_DOMAIN}${mainEntityPath}`
    } : undefined,
    primaryImageOfPage: {
      '@id': `${CC_DOMAIN}${primaryImageOfPagePath}`
    },
    breadcrumb: {
      '@id': `${CC_DOMAIN}${breadcrumbPath}`
    },
    inLanguage: 'en-AU',
    datePublished,
    dateModified
  })
}

export function GENERATE_BREADCRUMB_SCHEMA (payload = '') {
  const path = isArray(payload)
    ? payload.at(-1)?.url
    : payload

  const home = {
    name: 'Home',
    url: '/'
  }

  const crumbs = (() => {
    if (isArray(payload)) {
      return payload
    }

    const pathname = (payload && payload?.split('/')?.filter(Boolean) || [])
      .map((crumb, index, arr) => {
        const url = `/${arr.slice(0, index + 1).join('/')}/`

        return {
          name: crumb.replace(/-/g, ' ')
            .replace(/\b\w/g, c => c.toUpperCase()),
          url
        }
      })
    pathname.unshift(home)

    return pathname
  })()

  const itemListElement = crumbs.map((item, index) => {
    return {
      '@type': 'ListItem',
      position: index + 1,
      name: item?.name ?? item?.text ?? '',
      item: `${CC_DOMAIN}${item?.url ? item.url : '/'}`
    }
  })

  return removeFalseyObj({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    '@id': `${CC_DOMAIN}${path}#breadcrumb`,
    itemListElement
  })
}

export function GENERATE_SERVICE_SCHEMA ({
  page,
  name,
  serviceType,
  description,
  audienceName,
  servicePhone,
  trustpilot = {},
  catalog = [],
  catalogName,
  catalogDescription
} = {}) {
  const pageUrl = trailingSlash(`${CC_DOMAIN}${page}`)

  const obj = removeFalseyObj({
    '@type': 'Service',
    '@id': `${pageUrl}#service`,
    name,
    serviceType,
    description,
    url: pageUrl,
    provider: {
      '@id': `${CC_DOMAIN}/#organization`
    },
    areaServed: {
      '@type': 'Country',
      name: 'Australia'
    },
    audience: {
      '@type': 'Audience',
      name: audienceName
    },
    availableChannel: {
      '@type': 'ServiceChannel',
      servicePhone: servicePhone,
      serviceUrl: pageUrl
    },
    aggregateRating: GENERATE_AGGREGATE_RATING(trustpilot)
  })

  if (!_isEmpty(catalog)) {
    const itemListElement = catalog.map((item, index) => {
      return {
        '@type': 'Offer',
        position: index + 1,
        itemOffered: {
          '@type': 'Organization',
          name: item?.name ?? '',
          description: item?.description ?? '',
          url: item?.url ?? ''
        }
      }
    })

    obj.hasOfferCatalog = {
      '@type': 'OfferCatalog',
      '@id': `${pageUrl}#panel`,
      name: catalogName,
      description: catalogDescription,
      numberOfItems: catalog.length,
      itemListElement
    }
  }

  return obj
}

export function GENERATE_FAQ_SCHEMA ({
  page,
  faqs = []
} = {}) {
  if (_isEmpty(faqs)) {
    return null
  }

  const pageUrl = trailingSlash(`${CC_DOMAIN}${page}`)

  const mainEntity = faqs.map(faq => {
    const title = `${faq.title.replace(/\?/g, '').replace(/\s+/g, '-').toLowerCase()}`
    const id = `${CC_DOMAIN}${page}#faq-${title}`

    return removeFalseyObj({
      '@type': 'Question',
      '@id': id,
      name: faq.title,
      acceptedAnswer: {
        '@type': 'Answer',
        '@id': `${id}-answer`,
        text: faq.content
      }
    })
  })

  return removeFalseyObj({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    '@id': `${pageUrl}#faq`,
    isPartOf: {
      '@id': `${pageUrl}#webpage`
    },
    inLanguage: 'en-AU',
    mainEntity
  })
}

export function GENERATE_ARTICLE_SCHEMA ({
  page,
  slug,
  author,
  headline,
  description,
  datePublished,
  dateModified,
  audienceName
} = {}) {
  const pageUrl = trailingSlash(`${CC_DOMAIN}/${page}/${slug}`)

  return removeFalseyObj({
    '@type': 'Article',
    '@id': `${pageUrl}#article`,
    isPartOf: {
      '@id': `${pageUrl}#webpage`
    },
    mainEntityOfPage: {
      '@id': `${pageUrl}#webpage`
    },
    headline,
    description,
    image: {
      '@id': `${pageUrl}#primaryimage`
    },
    datePublished,
    dateModified,
    author: {
      '@id': `${CC_DOMAIN}/#person-${strToKebabCase(author)}`
    },
    publisher: {
      '@id': `${CC_DOMAIN}/#organization`
    },
    about: {
      '@id': `${trailingSlash(`${CC_DOMAIN}/${page}`)}#service`
    },
    audience: {
      '@type': 'Audience',
      name: audienceName
    },
    inLanguage: 'en-AU'
  })
}

export function GENERATE_PERSON_SCHEMA ({
  page,
  author,
  jobTitle,
  description,
  knowsAbout = [],
  isAuthorPage = false
} = {}) {
  const knowsAboutList = !_isEmpty(knowsAbout)
    ? knowsAbout.map(item => {
      return {
        '@type': 'Thing',
        name: item
      }
    })
    : null

  const pageUrl = trailingSlash(`${CC_DOMAIN}${page}`)

  const obj = {
    '@type': 'Person',
    '@id': `${CC_DOMAIN}/#person-${strToKebabCase(author)}`,
    'name': author,
    url: pageUrl,
    worksFor: {
      '@id': `${CC_DOMAIN}/#organization`
    },
    knowsAbout: knowsAboutList
  }

  if (jobTitle) {
    obj.jobTitle = jobTitle
  }

  if (description) {
    obj.description = description
  }

  if (isAuthorPage) {
    obj.mainEntityOfPage = {
      '@id': `${pageUrl}#webpage`
    }

    obj.image = {
      '@id': `${pageUrl}#image`
    }
  }

  return removeFalseyObj(obj)
}

export function GENERATE_ITEM_LIST_SCHEMA ({
  page,
  author,
  list = [],
  totalItems = 0
} = {}) {
  if (_isEmpty(list)) {
    return null
  }

  const pageUrl = trailingSlash(`${CC_DOMAIN}${page}`)

  const itemListElement = list.map((item, index) => {
    return {
      '@type': 'ListItem',
      position: index + 1,
      url: item?.url ?? '',
      name: item?.name ?? ''
    }
  })

  const obj = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    '@id': `${pageUrl}#articles`,
    name: `Articles by ${author}`,
    description: `Editorial content on compareclub.com.au authored by ${author}`,
    numberOfItems: totalItems || list?.length || 0,
    itemListOrder: 'https://schema.org/ItemListUnordered',
    itemListElement
  }

  return obj
}

export function GENERATE_PROFILE_SCHEMA ({
  page,
  list = []
} = {}) {
  const pageUrl = trailingSlash(`${CC_DOMAIN}${page}`)

  const profileList = list.map((item, index) => {
    return {
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': 'Person',
        'name': item?.name ?? '',
        'url': item?.url ?? '',
        'jobTitle': item?.jobTitle ?? ''
      }
    }
  })

  return removeFalseyObj({
    '@type': 'CollectionPage',
    '@id': `${pageUrl}#webpage`,
    url: `${pageUrl}`,
    mainEntity: {
      '@id': 'ItemList',
      'itemListElement': profileList
    }
  })
}